module.exports = __webpack_public_path__ + "img/phone-photos.ec07c26d.webp";